import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

/**
 * Class DictStorateService.
 *
 * Simple class to storoage data by keys (a dictionary).
 *
 */
export class DictStorageService {

  protected storage: { [index: string]: any } = {};

  constructor() {
    // Debug.
    window['rbstore'] = this;
  }

  public put(key: string, data: any) {
    this.storage[key] = data;
  }

  public get(key: string): any {
    return this.storage[key];
  }

  public keyExists(key: string): boolean {
    return typeof this.storage[key] !== 'undefined';
  }

  public remove(key: string) {
    delete this.storage[key];
  }

  public count(): number {
    return Object.keys(this.storage).length;
  }
  public putLang(lang: Object) {
    localStorage.setItem('lang', JSON.stringify(lang));

  }
  public getLang(): { LangID: string } {
    if (localStorage.getItem('lang') == null) {
      this.putLang({});
    }
    return JSON.parse(localStorage.getItem('lang'));
  }
  public setLangs(lang: string): void {
    this.put('langs', lang);

  }
  public getLangs(): Array<any> {
    return this.get('langs');
  }
}
